
import { ModelBase } from "@models/UpsertableBase";
import {
  Alignment, 
} from "@dndModels";
import { DataType } from "@dndModels/Types";


export class Deity extends ModelBase {
  data_type: DataType = "deity";
  alignment: Alignment = { 
    order: "Any", 
    moral: "Any" 
  };
  settings: string[] = []; // Forgotten Realms, Eberron, Dragonlance, Ravenloft, Spelljammer, etc
  native_planes: string[] = []; // Where they live
  divine_domains: string[] = []; // The domains they typically are associated with and their clerics can take
  associated_creatures: string[] = []; // IDs of creatures associated with this deity

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.alignment = obj.alignment ? obj.alignment : { 
        order: "Any", 
        moral: "Any" 
      };
      this.settings = obj.settings ? obj.settings : [];
      this.native_planes = obj.native_planes ? obj.native_planes : [];
      this.divine_domains = obj.divine_domains ? obj.divine_domains : [];
      this.associated_creatures = obj.associated_creatures ? obj.associated_creatures : [];
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.alignment = obj.alignment ? obj.alignment : { 
  //       order: "Any", 
  //       moral: "Any" 
  //     };
  //     this.settings = obj.settings ? obj.settings : [];
  //     this.native_planes = obj.native_planes ? obj.native_planes : [];
  //     this.divine_domains = obj.divine_domains ? obj.divine_domains : [];
  //     this.associated_creatures = obj.associated_creatures ? obj.associated_creatures : [];
  //   }
  // }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      alignment: this.alignment,
      settings: this.settings,
      native_planes: this.native_planes,
      divine_domains: this.divine_domains,
      associated_creatures: this.associated_creatures
    };
  }

  copy(copyMe: Deity, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.alignment = {...copyMe.alignment};
    this.settings = [...copyMe.settings];
    this.native_planes = [...copyMe.native_planes];
    this.divine_domains = [...copyMe.divine_domains];
    this.associated_creatures = [...copyMe.associated_creatures];
  }

  clone(drop_ids = false): Deity {
    const new_obj = new Deity();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}